import React from "react";
import clsx from "clsx";
import moment from "moment";
import SignaturePad from "react-signature-canvas";
import { ActivityInputValue } from "../../models";
import { ChangeEvent } from "react";
import { Checkbox } from "@fluentui/react";
import { DatePicker } from "@fluentui/react";
import { DefaultButton } from "@fluentui/react";
import { FC } from "react";
import { FormEvent } from "react";
import { Fragment } from "react";
import { InputValue } from "../../models";
import { MaskedTextField } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { MessageBar } from "@fluentui/react";
import { MessageBarType } from "@fluentui/react";
import { MutableRefObject } from "react";
import { PrimaryButton } from "@fluentui/react";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { GeneralService } from "../../services/GeneralService";

type IProps = {
  startInputValues?: ActivityInputValue[];
  inputValues: InputValue[];
  disabled: boolean;
  onClose(): void;
  onSubmit(actInputValues: ActivityInputValue[]): void;
  generalService?: GeneralService;
};
const classes = mergeStyleSets({
  inputBox: {
    borderRadius: 2,
    border: "1px solid #D8DFE6",
    fontSize: 14,
    marginBottom: 6,
    padding: "6px 4px",
    textAlign: "left",
    width: "100%",
  },
  inputBox2: {
    borderRadius: 2,
    border: "1px solid #D8DFE6",
    fontSize: 14,
    padding: "6px 4px",
    textAlign: "left",
    width: "100%",
  },
  dateTimeContainer: { display: "flex", alignItems: "flex-end", gap: 12 },
  label: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 20,
    display: "flex",
    alignItems: "center",
    letterSpacing: "0.005em",
    color: "#4C4C4C",
    textAlign: "left",
  },
  signCanvasContainer: {
    border: "1px solid #D8DFE6",
    background: "#fafafa",
    display: "flex",
    justifyContent: "center",
    position: "relative",
  },
  signClearButton: {
    border: "1px solid #D8DFE6",
    borderRadius: "2px",
    position: "absolute",
    right: 5,
    top: 5,
    fontSize: "11px",
  },
  signCanvas: {
    display: "flex",
    maxWidth: 300,
    width: "100%",
    height: "100%",
    margin: "auto",
    background: "#fff",
  },
});
const textInputStyles = {
  fieldGroup: classes.inputBox2,
};
const datePickerStyles = {
  textField: {
    border: "transparent",
    selectors: {
      ["& .ms-TextField-fieldGroup"]: {
        border: "1px solid #D8DFE6",
      },
    },
  },
};
const InputValuesForm: FC<IProps> = (props: IProps) => {
  const { inputValues, startInputValues, disabled, onClose } = props;
  const [fields, setFields] = useState<InputValue[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [showLargeForm, setShowLargeForm] = useState(false);

  const onChange = (name: string, value: any) => {
    const withAutoComputes = inputValues.filter((f) => f.formula !== undefined);
    const hasConditions = inputValues.filter((f) => f.conditions !== undefined);

    if (withAutoComputes.length > 0 || hasConditions.length > 0) {
      const form = document.getElementById("input-value-form") as
        | HTMLFormElement
        | undefined;
      if (form === undefined) return;
      const formElements = form.elements as typeof form.elements & {
        usernameInput: { value: string };
      };
      var filtered = Array.from(formElements)
        .filter((f: any) => f.name)
        .map((f: any) => ({
          name: f.id,
          value: f.type === "checkbox" ? f.checked : f.value,
        }));
      if (props.startInputValues) {
        filtered.push(
          ...props.startInputValues.map((i) => ({
            name: i.workPacketField ?? i.caption,
            value: i.value,
          }))
        );
      }

      for (const inputValue of withAutoComputes) {
        let formula = inputValue.formula;
        if (!formula) continue;
        for (let ctr = 0; ctr < filtered.length; ctr++) {
          formula = formula.replace(
            `'${filtered[ctr].name}'`,
            filtered[ctr].value
          );
        }

        let result = "";
        try {
          result = eval(formula);
        } catch (ex) {}

        let txt = document.getElementById(
          inputValue.name ?? inputValue.caption
        );
        if (txt) {
          txt.setAttribute("value", result);
          (txt as HTMLInputElement).value = result;
        }
      }

      if (hasConditions.length > 0) {
        var _inputValues = inputValues;
        for (var inputValue of hasConditions) {
          let conditions = inputValue.conditions;
          if (!conditions) continue;
          for (let ctr = 0; ctr < filtered.length; ctr++) {
            conditions = conditions.replace(
              filtered[ctr].name,
              filtered[ctr].value
            );
          }

          let result = true;
          try {
            result = eval(conditions);
          } catch (ex) {}
          if (!result) {
            _inputValues = _inputValues.filter(
              (f) => f.caption !== inputValue.caption
            );
          }
        }
        setFields(_inputValues);
      }
    }
  };

  const onSubmit = (e?: FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    var actInputValues: ActivityInputValue[] = [];
    for (const inputValue of inputValues) {
      if (inputValue.type === "html") continue;
      const inputElement = document.getElementById(
        inputValue.name ?? inputValue.caption
      ) as HTMLInputElement;
      if (!inputElement) continue;
      if (
        inputElement.getAttribute("aria-label") !== inputValue.caption &&
        inputElement.getAttribute("title") !== inputValue.caption
      )
        continue;
      var value = null;
      if (inputElement.getAttribute("hidden") === "hidden") continue;
      if (inputElement.type === "checkbox") {
        value = inputElement.checked;
      } else if (inputValue.type === "signature") {
        if (inputElement.value === null || inputElement.value === "") {
          setErrorMessage("Signature field is required.");
          return;
        }
        value = inputElement.value;
      } else {
        value = inputElement.value;
      }
      if (inputValue.group && inputElement) {
        const groupElements = document.getElementsByName(
          `--input-group-${inputValue.group}`
        );
        const hasChecked =
          Array.from(groupElements).filter((f: any) => f.checked).length > 0;
        if (!hasChecked) {
          setErrorMessage(`${inputValue.group} is required.`);
          return;
        }
      }
      actInputValues.push({
        caption: inputValue.caption,
        type: inputValue.type,
        value:
          value !== null ? (value + ` ${inputValue.unit ?? ""}`).trim() : null,
        workPacketField: inputValue.workPacketField ?? inputValue.name,
        workPacketValue: value,
      } as ActivityInputValue);
    }
    props.onSubmit(actInputValues);
  };

  useEffect(() => {
    if (inputValues) {
      var _inputValues = [];
      for (var inputValue of inputValues) {
        var __inputValue = { ...inputValue };
        if (__inputValue.default || __inputValue.autoPopulate) {
          const actInpVal = startInputValues?.find(
            (f) => f.caption === __inputValue.default
          );
          if (!__inputValue.autoPopulate) {
            __inputValue.autoPopulate = __inputValue.default;
          }

          const fieldValue = props.generalService?.getFieldValue(
            __inputValue.autoPopulate
          );
          const fromEntity =
            __inputValue.autoPopulate !== undefined &&
            __inputValue.autoPopulate.toString().split(":").length === 2;
          if (actInpVal?.value) {
            __inputValue.default = actInpVal.value;
          } else if (fieldValue) {
            __inputValue.default = fieldValue;
          } else if (fromEntity) {
            __inputValue.default = "";
          }
        }

        _inputValues.push(__inputValue);
      }
      const containsColSpan =
        _inputValues.filter((f) => f.colSpan !== undefined).length > 0;
      setShowLargeForm(containsColSpan);
      setFields(_inputValues);
    }
  }, []);

  return (
    <div>
      <form id="input-value-form" onSubmit={onSubmit}>
        <div className="ms-Grid" dir="ltr" style={{ marginTop: "20px" }}>
          {errorMessage && (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12">
                <MessageBar
                  messageBarType={MessageBarType.error}
                  onDismiss={() => setErrorMessage(undefined)}
                  dismissButtonAriaLabel="Close"
                >
                  {errorMessage}
                </MessageBar>
              </div>
            </div>
          )}

          {startInputValues && startInputValues.length > 0 && (
            <>
              {startInputValues
                .filter((f) => f.value != null && f.type !== "check")
                .map((inputVal, index: number) => (
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-md12"
                      style={{ textAlign: "left" }}
                    >
                      <div
                        key={`input-val-${index}`}
                        style={{ textAlign: "left", marginBottom: "10px" }}
                      >
                        <div style={{ fontSize: "14px" }}>
                          {inputVal.caption}
                        </div>

                        <input
                          className="form-control"
                          type="text"
                          value={inputVal.value}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                ))}
              {startInputValues.filter(
                (f) => f.value != null && f.type !== "check"
              ).length > 0 && <hr />}
            </>
          )}

          <div className="ms-Grid-row">
            {fields.map((field: InputValue, index: number) => (
              <Fragment key={`input-val-form-${index}`}>
                {field.type === "html" && (
                  <HtmlComponent inputValue={field} onChange={onChange} />
                )}
                {field.type === "text" && (
                  <TextComponent inputValue={field} onChange={onChange} />
                )}
                {field.type === "number" && (
                  <NumberComponent inputValue={field} onChange={onChange} />
                )}
                {field.type === "check" && (
                  <RadioComponent inputValue={field} onChange={onChange} />
                )}
                {field.type === "datetime" && (
                  <DateTimeComponent inputValue={field} onChange={onChange} />
                )}
                {field.type === "signature" && (
                  <SignatureComponent inputValue={field} onChange={onChange} />
                )}
              </Fragment>
            ))}
          </div>
          <div className="ms-Grid-row">
            {showLargeForm && <div className="ms-Grid-col ms-md6"></div>}
            <div
              className={`ms-Grid-col ms-md${showLargeForm ? 3 : 6}`}
              style={{ padding: "12px 5px 0 0" }}
            >
              <PrimaryButton
                id="btn-confirm-action"
                type="submit"
                disabled={disabled}
                className="action-button-submit"
              >
                Confirm
              </PrimaryButton>
            </div>
            <div
              className={`ms-Grid-col ms-md${showLargeForm ? 3 : 6}`}
              style={{ padding: "12px 0 0 5px" }}
            >
              <DefaultButton
                id="btn-cancel-action"
                onClick={onClose}
                disabled={disabled}
                className="action-button-submit"
              >
                Cancel
              </DefaultButton>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default InputValuesForm;

type IComponentProps = {
  inputValue: InputValue;
  onChange(name: string, value: any): void;
};
const HtmlComponent: FC<IComponentProps> = (props: IComponentProps) => {
  const { inputValue } = props;

  return (
    <div
      className={`ms-Grid-col ms-md${inputValue.colSpan ?? "12"}`}
      style={{ textAlign: "left", fontSize: 12 }}
    >
      <span>{inputValue.caption}</span>
    </div>
  );
};

const TextComponent: FC<IComponentProps> = (props: IComponentProps) => {
  const { inputValue } = props;

  return (
    <div
      className={`ms-Grid-col ms-md${inputValue.colSpan ?? "12"}`}
      style={{ textAlign: "left" }}
    >
      <label className={classes.label}>{inputValue.caption}</label>
      <div>
        <input
          id={inputValue.name ?? inputValue.caption}
          name={inputValue.name ?? inputValue.caption}
          className={classes.inputBox}
          type="text"
          aria-label={inputValue.caption}
          defaultValue={inputValue.default}
          disabled={inputValue.disabled}
          placeholder={`Enter ${inputValue.caption}`}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            props.onChange(
              inputValue.name ?? inputValue.caption,
              e.currentTarget.value
            )
          }
          required
        />
      </div>
    </div>
  );
};

const NumberComponent: FC<IComponentProps> = (props: IComponentProps) => {
  const { inputValue } = props;

  return (
    <div
      className={`ms-Grid-col ms-md${inputValue.colSpan ?? "12"}`}
      style={{
        textAlign: "left",
        display: inputValue.hidden ? "none" : "block",
      }}
    >
      <label className={classes.label}>{inputValue.caption}</label>
      <div>
        <input
          id={inputValue.name ?? inputValue.caption}
          name={inputValue.name ?? inputValue.caption}
          className={classes.inputBox}
          type="number"
          aria-label={inputValue.caption}
          defaultValue={inputValue.default}
          min={inputValue.minimum}
          max={inputValue.maximum}
          disabled={inputValue.disabled}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            props.onChange(
              inputValue.name ?? inputValue.caption,
              e.currentTarget.value
            )
          }
          required
        />
      </div>
    </div>
  );
};

const RadioComponent: FC<IComponentProps> = (props: IComponentProps) => {
  const { inputValue } = props;
  const { group, disabled } = inputValue;
  const [isChecked, setIsChecked] = useState<boolean>();

  useEffect(() => {
    props.onChange(inputValue.name ?? inputValue.caption, isChecked);
  }, [isChecked]);

  return (
    <div
      className={`ms-Grid-col ms-md${inputValue.colSpan ?? "12"}`}
      style={{
        textAlign: "left",
        display: inputValue.hidden ? "none" : "block",
      }}
    >
      <div style={{ margin: "6px 0" }}>
        <Checkbox
          id={inputValue.name ?? inputValue.caption}
          name={group !== undefined ? `--input-group-${group}` : undefined}
          label={inputValue.caption}
          title={inputValue.caption}
          //placeholder={inputValue.caption}
          defaultChecked={inputValue.default === "true"}
          onChange={(ev, checked) => {
            if (group && checked) {
              const elements = document.getElementsByName(
                `--input-group-${group}`
              );
              Array.from(elements).forEach((element: HTMLElement) => {
                const inputElement = element as HTMLInputElement;
                if (inputElement.checked) {
                  inputElement.click();
                }
              });
            }
            setIsChecked(checked);
          }}
          checked={isChecked}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

const DateTimeComponent: FC<IComponentProps> = (props: IComponentProps) => {
  const { inputValue } = props;
  const [dateValue, setDateValue] = useState<Date>();
  const [timeValue, setTimeValue] = useState<string>();
  const [dateTimeValue, setDateTimeValue] = useState<string>();

  const onSelectDate = (date: Date | null | undefined) => {
    if (date !== null) {
      setDateValue(date);
    }
    if (date) {
      const vals = timeValue ? timeValue.split(":") : "00:00";
      date.setHours(parseInt(vals[0], 10));
      date.setMinutes(parseInt(vals[1], 10));

      setDateTimeValue(date.toISOString());
    }
  };

  const onEditTime = (_e: any, value?: string) => {
    setTimeValue(value);
    if (value && dateValue) {
      value = value.replace("_", "");
      if (value.length !== 5) return;
      let date = new Date(dateValue);
      const vals = value.split(":");
      date.setHours(parseInt(vals[0], 10));
      date.setMinutes(parseInt(vals[1], 10));

      //if (validate(date.toISOString())) {
      setDateTimeValue(date.toISOString());
      //}
    }
  };

  return (
    <div
      className={clsx(
        `ms-Grid-col ms-md${inputValue.colSpan ?? "12"}`,
        classes.dateTimeContainer
      )}
    >
      <input
        id={inputValue.name ?? inputValue.caption}
        name={inputValue.name ?? inputValue.caption}
        type="hidden"
        value={dateTimeValue ?? ""}
      />
      <div style={{ flex: 1, textAlign: "left", minWidth: 120 }}>
        <DatePicker
          label={inputValue.caption}
          aria-label={inputValue.caption}
          formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
          placeholder={`Enter ${inputValue.caption}`}
          styles={datePickerStyles}
          disabled={inputValue.disabled}
          onSelectDate={onSelectDate}
          value={dateValue}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              e.currentTarget.blur();
            }
          }}
        />
      </div>
      <div>
        <MaskedTextField
          mask="12:32"
          aria-label={inputValue.caption}
          maskFormat={{
            "1": /[0-2]/,
            "2": /[0-9]/,
            "3": /[0-5]/,
          }}
          styles={textInputStyles}
          disabled={inputValue.disabled}
          iconProps={{ iconName: "Clock" }}
          onChange={onEditTime}
          value={timeValue}
        />
      </div>
    </div>
  );
};

const SignatureComponent: FC<IComponentProps> = (props: IComponentProps) => {
  const { inputValue } = props;
  const [signatureData, setSignatureData] = useState<string>();
  const signCanvas = useRef() as MutableRefObject<any>;

  const onDrawEnd = () => {
    var signData = signCanvas.current.getTrimmedCanvas().toDataURL("");
    setSignatureData(signData);
  };

  const onClear = () => {
    setSignatureData(undefined);
    if (signCanvas.current) {
      signCanvas.current.clear();
    }
  };

  return (
    <div className={`ms-Grid-col ms-md${inputValue.colSpan ?? "12"}`}>
      <input
        id={inputValue.name ?? inputValue.caption}
        name={inputValue.name ?? inputValue.caption}
        value={signatureData}
        type="hidden"
      />
      <label className={classes.label}>{inputValue.caption}</label>
      <div
        className={classes.signCanvasContainer}
        style={{ height: (inputValue.colSpan ?? 12) > 3 ? 120 : 90 }}
      >
        {signatureData && (
          <DefaultButton onClick={onClear} text="Clear" />
          //<button onClick={onClear} className={classes.signClearButton}>
          //  Clear
          //</button>
        )}
        <SignaturePad
          ref={signCanvas}
          canvasProps={{
            className: classes.signCanvas,
          }}
          clearOnResize={false}
          penColor="black"
          onEnd={onDrawEnd}
        />
      </div>
    </div>
  );
};
